import { Theme } from '@mui/material'

const useStyles = {
  urgentAlertsBannerIcon: (theme: Theme) => ({ color: theme.palette.error.main }),
  urgentAlertsBannerText: { fontWeight: 600 },
  urgentAlertsBanner: (theme: Theme) => ({ width: '100%', backgroundColor: theme.palette.error.light }),
}

export default useStyles
